import React, { Component } from 'react';
import '@ant-design/v5-patch-for-react-19';
import {Amplify} from 'aws-amplify';
import AppRouter from './AppRouter.js';
import Spinner from './Components/Theme/Spinner/index.js';
import { connect } from 'react-redux';
import * as authActions from './redux/actions/authActions.js';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import AWSMobile from './aws-exports.js';

const PRODUCTION_MFA_URL = 'https://d2poqa4uhfcz8f.cloudfront.net/';

Amplify.configure({
  API: {
    GraphQL:{
      endpoint: AWSMobile.aws_appsync_graphqlEndpoint,
      defaultAuthMode: AWSMobile.aws_appsync_authenticationType,
      apiKey: AWSMobile.aws_api_key,
    }
  }
});


const redirectSignIn = window.location.origin;
export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authState: 'initialPageLoad'
    }
  }

  async componentDidMount() {
    const code = this.getQueryParams().code;
    if (!this.props.user.login && code ) {
      this.setState({
      authState: 'backfromFSSWaitingForClaim'
      });
      console.log(`code is ${code}`)
      await this.props.actions.fetchAuth(code)
         .catch(error => {
          alert("Fetch Auth failed\n" + JSON.stringify(error));
        });
      const { sso } = await this.props.auth;
      //const sso = '206647428';
      //const sso = '502101080';  //Josue
      //const sso = '206408475' //Raul

      await this.props.actions.fetchUserSession(sso).catch(error => {
        alert("Fetch User Session failed\n" + JSON.stringify(error));
      });

      //this.adminMFAValidation(this.props.user);

      this.setState({
        authState: 'signedIn'
      });
    }
    if (!this.props.user.login && !code) {
        this.redirectToFSS();
    }
    if (this.props.user.login) {
      // prevent user from hitting browser back-button after adminEnvRedirect
      if (this.props.user.adminEnvRedirect.result) {
        window.location.href = PRODUCTION_MFA_URL; // prod-mfa environment
      }
      this.setState({
        authState: 'signedIn'
      });
    }
  }

  redirectToFSS = () => {
    const redirectSignIn = window.location.origin;
    window.location.href = `${AWSMobile.oauth_base_url}/oauth2/v2.0/authorize?client_id=${AWSMobile.clientId}&response_type=code&scope=${encodeURIComponent(AWSMobile.oauth_scope)}&redirect_uri=${redirectSignIn}/`;

  };

  getQueryParams = () => {
    let queryParams = {};
    //create an anchor tag to use the property called search
    let anchor = document.createElement('a');
    //assigning url to href of anchor tag
    anchor.href = window.location.href;
    //search property returns the query string of url
    let queryStrings = anchor.search.substring(1);
    let params = queryStrings.split('&');

    for (let i = 0; i < params.length; i++) {
        let pair = params[i].split('=');
        queryParams[pair[0]] = decodeURIComponent(pair[1]);
    }
    return queryParams;
  }

  // redirect admin users to prod-mfa env in production
  adminMFAValidation = async (user) => {
    if (user.adminEnvRedirect.result) {
      alert('You are an admin and are now being redirected to the admin production environment.');
      window.location.href = PRODUCTION_MFA_URL; // prod-mfa environment
    }
  }


  render() {
    const { authState } = this.state;
    const { user, auth } = this.props;
    console.log(`authState: ${authState}`);
    return (
        <div className="App">
          {
            (authState === 'signedIn' && this.props.user.login)
            ? <AppRouter/>
            : <Spinner />
          }
        </div>
    );
  }
}

App.propTypes = {
  actions: PropTypes.object.isRequired,
  auth: PropTypes.object,
  user: PropTypes.object
};

function mapStateToProps(state) {
  return {
      auth: state.auth,
      user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
      actions: {
          fetchAuth: bindActionCreators(
              authActions.fetchAuth,
              dispatch
          ),
          fetchUserSession: bindActionCreators(
            authActions.fetchUserSession,
            dispatch
        ),
      }
  };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
   )(App);

